import { NotificationsState } from './state';
import { notificationsInitialState } from './initial-state';
import { NotificationsActions } from './action-creators';
import * as actions from './actions';

export const notificationsReducer = (
  state: NotificationsState = notificationsInitialState,
  action: NotificationsActions
): NotificationsState => {
  switch (action.type) {
    case actions.LIST_NOTIFICATIONS: {
      return {
        ...state,
        items: action.nextToken ? state.items : [],
      };
    }

    case actions.LIST_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        items: state.items.concat(action.notifications),
      };
    }

    case actions.CLEAR_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        items: action.notificationId
          ? state.items.filter((i) => i.id !== action.notificationId)
          : [],
      };
    }

    case actions.ALL_NOTIFICATIONS_LOADED: {
      return {
        ...state,
        notificationLoaded: true,
      };
    }

    case actions.MARK_AS_READ_SUCCESS: {
      return {
        ...state,
        items: state.items.map((i) => ({
          ...i,
          status: 'read',
        })),
      };
    }

    case actions.SET_POPUP_NOTIFICATION: {
      return {
        ...state,
        popupNotificationPayload: action.payload,
      };
    }

    case actions.UPDATE_NOTIFICATION_INVITE_STATUS: {
      return {
        ...state,
        items: state.items.map((notification) => {
          if (
            notification.id === action.notificationId &&
            notification.invite
          ) {
            return {
              ...notification,
              invite: {
                ...notification.invite,
                status: action.newStatus,
              },
            };
          }

          return notification;
        }),
      };
    }

    default: {
      return { ...state };
    }
  }
};
